import slug from 'slugg';

/**
 * helper para paths & url del site
 */
class UrlHelper {
  constructor() {
    this.countryCode = 'all';
  }

  getCountryCode() {
    return this.countryCode;
  }

  setCountryCode(country) {
    this.countryCode = country;
    return this;
  }

  connect(store) {
    const unsubscribeStore = store.subscribe(() => {
      const state = store.getState();

      if (state.apiLogin && state.apiLogin.country) {
        unsubscribeStore();

        this.setCountryCode(state.apiLogin.country);
      }
    });
  }

  prependCountryToPath(path) {
    if (!path) {
      path = '/';
    }

    if (path.charAt(0) !== '/') {
      path = `/${path}`;
    }

    const cCode = `/${this.getCountryCode().toLowerCase()}`;

    if (path === cCode || path.startsWith('cCode/')) {
      return path;
    }

    return cCode + path;
  }

  buildProfilesPath(section, root = '/profiles') {
    return this.prependCountryToPath(root + section);
  }

  getPathSlugForFicha(content) {
    let path = '';
    if (content.serie && content.serie.id) {
      path = `serie/${this.getPathForContent(content.serie, true)}`.toLowerCase();

      if (content.contentType === 'EPISODE') {
        path = this.addSeansonAndEpisodeToPath(path, content);
      }
    } else {
      path = this.getPathForContent(content);

      if (content.contentType && content.contentType.trim() !== '') {
        path = `${content.contentType.toLowerCase()}/${path}`;
      }
    }

    return path;
  }

  addSeansonAndEpisodeToPath(path, content) {
    if (content.episode && content.season) {
      return `${path}?season=${content.season}&episode=${content.shortId}`;
    }
    return path;
  }

  getPathSlug(content) {
    let path = '';

    // Si es un link a un episodio, debe navegar hacia la ficha de la serie
    if (content.serie && content.serie.id) {
      const id = content.shortId || content.id;

      const serieSlug = slug(content.serie.title || content.serie.shortId || content.serie.id);
      const titleSlug = slug(content.title || content.episode || 'e');

      path = `serie/${serieSlug}/${titleSlug}_${id}`.toLowerCase();
    } else {
      path = this.getPathForContent(content);

      if (content.contentType && content.contentType.trim() !== '') {
        path = `${content.contentType.toLowerCase()}/${path}`;
      }
    }

    return path;
  }

  buildFichaPathFromContent(content) {
    content._expLink = this.prependCountryToPath(this.getPathSlugForFicha(content));

    return content._expLink;
  }

  buildPlayPathFromContent(content) {
    content._expPlayLink = this.prependCountryToPath(`/player/${this.getPathSlug(content)}`);

    return content._expPlayLink;
  }

  buildPlayPathFromRecordedContent(content, recordedId, from, to) {
    const fromText = from ? `&from=${from}` : '';
    const toText = to ? `&to=${to}` : '';

    content._expPlayLink = this.prependCountryToPath(`/player/${this.getPathSlug(content)}?id=${recordedId}${fromText}${toText}`);

    return content._expPlayLink;
  }

  buildPlayExternalPathFromContent(content) {
    const path = this.getPathForContent(content);

    content._expEPlayLink = `/play-external/${path}`;

    return content._expEPlayLink;
  }

  // old methods:

  buildSectionPath(sectionURL, location = '') {
    // TODO: usar el location una vez lo tengamos.
    const path = location ? `/${location}${sectionURL}` : sectionURL;

    return this.prependCountryToPath(path);
  }

  buildSectionPathFromSection(section) {
    if (section._expLink) {
      return section._expLink;
    }

    section._expLink = this.buildSectionPath(section.url);

    return section._expLink;
  }

  getPathForContent(content, serie = false) {
    // eventualmente content no trae shortId, y biene en id
    const shortId = content.shortId || content.id;
    // Fallback para contenidos que vienen sin short id
    // Solo en caso de no tener shortId y no venga de serie se devuelve solo id
    // Desconozco el caso para cuando solo deba recibir ID, se probaron tipos de contenidos principales
    if (!content.shortId && !serie) {
      return content.id;
    }

    // TODO: pasar generacion de slug a Unity?
    const titleSlug = slug((content.title || '').toLowerCase());

    return `${titleSlug}_${shortId}`;
  }

  extractContentIdFromPath(path) {
    // TODO: fix para matchear contenidos sin _id (ej serie en episode)
    // let matches = path.match(/.*_(.{6})/);
    const pathandsearch = path.split('?');
    const search = pathandsearch[1] ? `?${pathandsearch[1]}` : '';
    const matches = pathandsearch[0].match(/.*_(.*)/);
    let contentId;

    if (matches) {
      contentId = matches[1] + search;
    } else {
      contentId = path;
    }

    return contentId;
  }

  getParamsMap() {
    const searchString = window.location.search;
    if (!searchString) {
      return null;
    }
    // eslint-disable-next-line
    let map = {};

    searchString.split(/[?&]+/).forEach((e) => {
      if (e && e.length > 0) {
        const eMap = e.split('=');
        map[eMap[0]] = eMap[1]
      }
    });
    return map;
  }

  transformQueryStringToMap(query) {
    const params = query.split(/(\?|&)/).filter(e => e && e !== '?' && e !== '&');
    const map = {};
    params.forEach((p) => {
      map[p.split('=')[0]] = decodeURIComponent(p.split('=')[1]);
    });
    return map;
  }

  getPathForMyAccount(countryCode) {
    return `${window.location.origin}/${countryCode.toLowerCase()}/my-account`;
  }
}

const helper = new UrlHelper();
export default helper;
